<template>
    <div class="track-trip-form" v-loading="loading">
        <div class="track-trip-form__header">
            <div class="track-trip-form__header-title">ВНИМАНИЕ!</div>
            <span class="track-trip-form__header-descript">
                Проверьте личные данные на форме регистрации и выберите город отправления для перехода к выбору
                БЕСПЛАТНОЙ ПОЕЗДКИ
            </span>
        </div>
        <p class="track-trip-form__pass-descript">
            Данные для получения сертификата должны быть указаны на русском языке и в соответствии с Вашим паспортом.
        </p>
        <div class="track-trip-form__wrapper">
            <div class="track-trip-form__content">
                <div class="track-trip-form__info">
                    <div class="track-trip-form__info-item">
                        <div class="track-trip-form__info-name">
                            <b>{{ getTripStatus.surname }} {{ getTripStatus.name }} {{ getTripStatus.patronymic }}</b>
                        </div>
                        <div class="track-trip-form__info-date">
                            Дата рождения:
                            <b>
                                <template v-if="this.getTripStatus.birthdate">{{
                                    this.getTripStatus.birthdate | fullIsoDate
                                }}</template>
                                <template v-else>не указана</template>
                            </b>
                        </div>
                    </div>
                    <div class="track-trip-form___info-item">
                        <div class="track-trip-form__info-button-wrapper">
                            <div class="track-trip-form__info-button-question">Ошибка в данных?</div>
                            <btn class="track-trip-form__btn" @click="showPopup">
                                Обратиться в поддержку
                                <img
                                    src="~@/assets/images/icons/email.svg"
                                    width="15px"
                                    height="15px"
                                    style="margin-left: 10px"
                                />
                            </btn>
                        </div>
                    </div>
                </div>
                <p class="track-trip-form__city-note">
                    Если вы обнаружили несоответствие данных с паспортом, необходимо обратиться в поддержку для внесения
                    изменений. В противном случае при обнаружении ошибки туроператором вам будет отказано в поездке.
                </p>
                <div class="track-trip-form__confirm-wrapper">
                    <ModelCheckbox
                        class="track-trip-form__confirm-checkbox"
                        :input-value="isConfirm.pass"
                        @change="confirmPassToggle"
                    />
                    <span class="track-trip-form__confirm-text"
                        >Подтверждаю, что мои данные совпадают с паспортными данными</span
                    >
                </div>
                <hr class="hr" />
                <ModelSelect
                    class="model"
                    label="Выберите удобный для вас город отправления"
                    item-value="cityId"
                    item-text="city"
                    :items="getTripCities"
                    v-model="departure"
                >
                </ModelSelect>
                <p class="track-trip-form__city-note">
                    Обратите внимание, город отправления можно выбрать только один раз. После отправки формы изменение
                    города невозможно.
                </p>
                <p class="track-trip-form__city-note">
                    <b>Внимание!</b> Дорога до города отправления оплачивается участником самостоятельно.
                </p>
            </div>
            <div class="track-trip-form__footer">
                <div class="track-trip-form__footer-notes-wrapper">
                    <div class="track-trip-form__confirm">
                        <ModelCheckbox
                            class="track-trip-form__confirm-checkbox"
                            :input-value="isConfirm.main"
                            @change="confirmMainToggle"
                        />
                        <p class="track-trip-form__confirm-note">
                            Подтверждаю, что ознакомлен
                            <a class="track-trip-form__confirm-link" :href="getActPdfLink" target="_blank">
                                с положением о проекте "Больше, чем путешествие"
                            </a>
                            и даю свое согласие на участие в проекте. Для несовершеннолетних - подтверждаю, что согласие
                            законного представителя получено.
                        </p>
                    </div>
                    <div class="track-trip-form__confirm">
                        <ModelCheckbox
                            class="track-trip-form__confirm-checkbox"
                            :input-value="isConfirm.medias"
                            @change="confirmMediaToggle"
                        />
                        <p class="track-trip-form__confirm-note">
                            Согласен с осуществлением фото и видео съемки, обнародование и использование изображений на
                            фотографических произведениях, видео-произведениях и произведениях, полученных способами,
                            аналогичными фотографии.
                        </p>
                    </div>
                </div>
                <btn class="track-trip-form__btn" :disabled="isDisabled" @click="save">
                    Coхранить и перейти к выбору поездки
                </btn>
            </div>
        </div>
        <FeedBackPopup v-model="popupToggle" />
    </div>
</template>

<script>
import moment from 'moment';
import ModelCheckbox from '@/components/UI/models/ModelCheckbox';
import FeedBackPopup from '@/components/UI/FeedBackPopup';
import Btn from '@/components/UI/Button';
import { dateOfBirthValidator, ageRating } from '@/tools/age';
import { mapGetters, mapActions } from 'vuex';
import ModelSelect from '@/components/UI/models/ModelSelect';

const actions = ['loadTripCities', 'loadStateStatus', 'loadProfileData', 'saveTripData'];

const getters = ['getTripCities', 'getTripStatus', 'user', 'userProfileInfo', 'getActPdfLink'];

export default {
    name: 'TrackTripForm',
    components: {
        Btn,
        ModelCheckbox,
        ModelSelect,
        FeedBackPopup,
    },
    data: () => ({
        isDisableForm: true,
        isConfirm: {
            main: false,
            medias: false,
            pass: false,
        },
        popupToggle: false,
        minYear: 1900,
        maxYear: new Date().getFullYear() - ageRating,
        dateOfBirthValidator: dateOfBirthValidator,
        loading: false,
        departure: null,
    }),
    computed: {
        ...mapGetters(getters),
        isDisabled() {
            return this.isDisableForm || !this.isConfirm.main || !this.isConfirm.medias || !this.isConfirm.pass;
        },
    },
    methods: {
        ...mapActions(actions),
        confirmPassToggle() {
            this.isConfirm.pass = !this.isConfirm.pass;
        },
        showPopup() {
            console.log(this.popupToggle);
            this.popupToggle = true;
            console.log(this.popupToggle);
        },
        confirmMainToggle() {
            this.isConfirm.main = !this.isConfirm.main;
        },
        confirmMediaToggle() {
            this.isConfirm.medias = !this.isConfirm.medias;
        },
        clearAdress() {
            this.departure = null;
        },
        async save() {
            const userId = this.user.id;
            const departure = this.departure;
            const tripData = {
                departure,
                userId,
            };

            try {
                this.loading = true;
                await this.saveTripData(tripData);
                await this.loadStateStatus();
                window.location = `https://${this.getTripStatus.link_to_sletay}`;
            } finally {
                this.loading = false;
            }
        },
    },
    async created() {
        await this.loadTripCities();
        await this.loadStateStatus();
    },
    watch: {
        departure: {
            handler(val) {
                this.isDisableForm = !val;
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';
@import '@/styles/mrem';
$defaultTheme: #713dd3;

::v-deep .label {
    overflow: hidden;
}

.hr {
    margin: 20px 0 30px 0;
    color: $defaultTheme;
}

.model {
    @include on-desktop {
        width: rem(440);
    }
}

.track-trip-form {
    @include on-desktop {
        flex-direction: row;
        overflow: hidden;
        margin-top: 0;
        background-color: #f5f9fc;
        border-radius: 10px;
        border: 1px solid #ccc;
    }

    &__confirm-text {
        font-size: mrem(14);
        line-height: mrem(18);
        @include on-desktop {
            font-size: rem(14);
            line-height: rem(18);
        }
    }

    &__confirm-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
    }

    &__info {
        font-size: mrem(24);

        @include on-desktop {
            font-size: rem(19);
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        &-name {
            @include on-desktop {
                font-weight: 600;
                margin-bottom: 10px;
            }
        }

        &-date {
            font-weight: 100;
        }
    }

    &__info-button {
        &-wrapper {
            border: 1px dashed #713dd3;
            padding: mrem(15) mrem(15);
            @include on-desktop {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: rem(15) rem(15);
            }
        }

        &-question {
            margin-right: 10px;
            color: #713dd3;
            font-weight: 600;
        }
    }

    &__pass-descript {
        font-size: mrem(12);
        @include on-desktop {
            margin-left: 42px;
            font-size: rem(18);
            line-height: rem(36);
        }
    }

    &__wrapper {
        background-color: #ffffff;
        padding: mrem(40) mrem(18) mrem(20) mrem(18);
        @include on-desktop {
            margin: 0 42px 0 42px;
            padding: rem(40) rem(40);
            background-color: #ffffff;
        }
    }

    &__confirm-text {
        font-size: mrem(14);
        line-height: mrem(18);
        @include on-desktop {
            font-size: rem(14);
            line-height: rem(18);
        }
    }

    &__confirm-wrapper {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
    }

    &__info {
        font-size: mrem(24);

        @include on-desktop {
            font-size: rem(19);
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        &-item {
            margin-bottom: 10px;
        }

        &-name {
            margin-bottom: 10px;

            @include on-desktop {
                font-size: rem(24);
                font-weight: 600;
                margin-bottom: 10px;
            }
        }

        &-date {
            font-weight: 100;

            @include on-desktop {
                font-size: rem(24);
            }
        }
    }

    &__info-button {
        &-wrapper {
            border: 1px dashed #713dd3;
            padding: mrem(15) mrem(15);
            @include on-desktop {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: rem(15) rem(15);
            }
        }

        &-question {
            margin-right: 10px;
            margin-bottom: 10px;
            color: #713dd3;
            font-weight: 600;

            @include on-desktop {
                margin-bottom: 0;
            }
        }
    }

    &__pass-descript {
        font-size: mrem(16);
        padding: mrem(0) mrem(18) mrem(0) mrem(18);
        @include on-desktop {
            margin-left: 42px;
            font-size: rem(22);
            line-height: rem(36);
            padding: 0;
        }
    }

    &__wrapper {
        background-color: #ffffff;
        padding: mrem(20) mrem(18) mrem(20) mrem(18);
        @include on-desktop {
            margin: 0 42px 42px 42px;
            padding: rem(40) rem(40);
            background-color: #ffffff;
        }
    }

    &__header {
        font-weight: 600;
        font-size: mrem(24);
        color: #ffffff;
        padding: mrem(15) 0 mrem(15) mrem(18);
        border-radius: mrem(10) mrem(10) mrem(0) mrem(0);
        background: $defaultTheme;

        &-title {
            margin-bottom: 10px;
        }

        &-descript {
            font-size: mrem(16);
            line-height: 0.5;
            @include on-desktop {
                font-size: rem(22);
                line-height: rem(36);
            }
        }

        @include on-desktop {
            font-size: rem(24);
            line-height: rem(36);
            padding: rem(42) 0 rem(34) rem(42);
            font-weight: 600;
            font-size: rem(36);
            line-height: rem(26);
            border-radius: rem(10) rem(10) rem(0) rem(0);

            br {
                display: none;
            }
        }
    }

    &__input {
        @include on-desktop {
            margin-bottom: rem(40);
        }
    }

    &__footer {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: #fff;
        @include on-desktop {
            display: flex;
            justify-content: space-between;
        }
    }

    &__footer-notes-wrapper {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // padding: 0 mrem(18) mrem(20) mrem(18);
        // margin-bottom: mrem(40);
        // background: #fff;
        @include on-desktop {
            width: 100%;
            margin-bottom: rem(40);
        }
    }

    &__confirm-checkbox {
        align-items: flex-start;
        margin-bottom: 0;
    }

    &__confirm {
        display: flex;
        align-items: baseline;
        font-size: mrem(14);
        line-height: mrem(24);
        width: 100%;

        &:first-child {
            margin-bottom: 20px;
        }

        @include on-desktop {
            align-items: baseline;
            font-size: rem(14);
            line-height: rem(24);
        }
    }

    &__confirm-link {
        margin-left: mrem(4);
        color: $defaultTheme;
        text-decoration: none;
        @include on-desktop {
            margin-left: rem(2);
        }
    }

    &__confirm-note {
        @include on-desktop {
            margin: 0;
        }
    }

    &__city-note {
        font-size: mrem(14);
        line-height: mrem(18);
        color: $defaultTheme;
        @include on-desktop {
            font-size: rem(20);
            line-height: rem(30);
        }
    }

    &__btn {
        padding: mrem(12) mrem(10);
        color: #fff;
        background: $defaultTheme;
        @include on-desktop {
            padding: rem(12) rem(10);
        }
    }
}
</style>
